export const MerkleAddressLocal = "0xb52A99Fb7c14aFaFfEC46a59b0352A0349d9D2E3"

export const MerkleAddressKovan = "0xe204B5586537Dda0694Ac3B4AA7FD5eD0C288665"

export const MerkleAddressMain = "0x46FEEBDffC8076D9E5fd8a11CF1508810472A79f"

export function getMerkleAddress(networkName) {
  switch (networkName) {
    case "local":
      return MerkleAddressLocal
    case "kovan":
      return MerkleAddressKovan
    case "main":
      return MerkleAddressMain
    default:
      return MerkleAddressLocal
  }
}

export const MerkleAbi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        name: "id",
        type: "uint256"
      },
      {
        indexed: false,
        name: "root",
        type: "bytes32"
      },
      {
        indexed: false,
        name: "balance",
        type: "uint256"
      },
      {
        indexed: false,
        name: "registryTotal",
        type: "uint256"
      }
    ],
    name: "MerklesendCreate",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        name: "id",
        type: "uint256"
      },
      {
        indexed: false,
        name: "from",
        type: "address"
      },
      {
        indexed: false,
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        name: "amount",
        type: "uint256"
      }
    ],
    name: "MerklesendSuccess",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        name: "id",
        type: "uint256"
      },
      {
        indexed: false,
        name: "from",
        type: "address"
      },
      {
        indexed: false,
        name: "remainder",
        type: "uint256"
      }
    ],
    name: "MerklesendCancelled",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        name: "id",
        type: "uint256"
      },
      {
        indexed: false,
        name: "from",
        type: "address"
      }
    ],
    name: "MerklesendCancellabilityRevoked",
    type: "event"
  },
  {
    constant: true,
    inputs: [
      {
        name: "id",
        type: "uint256"
      }
    ],
    name: "getRewardPool",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        name: "id",
        type: "uint256"
      }
    ],
    name: "getRemainingBalance",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        name: "id",
        type: "uint256"
      },
      {
        name: "who",
        type: "address"
      }
    ],
    name: "getRedeemed",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        name: "id",
        type: "uint256"
      }
    ],
    name: "getSenderInfo",
    outputs: [
      {
        name: "merkleRoot",
        type: "bytes32"
      },
      {
        name: "remainingBalance",
        type: "uint256"
      },
      {
        name: "rewardPool",
        type: "uint256"
      },
      {
        name: "registryTotal",
        type: "uint256"
      },
      {
        name: "creator",
        type: "address"
      },
      {
        name: "erc20",
        type: "address"
      },
      {
        name: "cancellable",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        name: "id",
        type: "uint256"
      }
    ],
    name: "revokeCancellability",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        name: "id",
        type: "uint256"
      }
    ],
    name: "cancelMerkleSender",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        name: "id",
        type: "uint256"
      },
      {
        name: "erc20",
        type: "address"
      },
      {
        name: "root",
        type: "bytes32"
      },
      {
        name: "balance",
        type: "uint256"
      },
      {
        name: "registryTotal",
        type: "uint256"
      },
      {
        name: "cancellable",
        type: "bool"
      }
    ],
    name: "createMerkleSender",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        name: "id",
        type: "uint256"
      },
      {
        name: "amount",
        type: "uint256"
      },
      {
        name: "beneficiary",
        type: "address"
      }
    ],
    name: "availableRewardCalculation",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        name: "id",
        type: "uint256"
      },
      {
        name: "beneficiary",
        type: "address"
      },
      {
        name: "amount",
        type: "uint256"
      },
      {
        name: "proof",
        type: "bytes32[]"
      }
    ],
    name: "withdraw",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  }
]
